"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = ['AK', 'AR', 'CT', 'HI', 'KY', 'MA', 'MI', 'MN', 'NH', 'NJ', 'NM', 'NY', 'OR', 'PA', 'RI', 'TX', 'VT', 'WA', 'WI', 'UM'];
exports["default"] = _default;